import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatsappVideoRoutingModule } from './whatsapp-video-routing.module';
import { WhatsappVideoComponent } from './whatsapp-video.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';


@NgModule({
  declarations: [
    WhatsappVideoComponent
  ],
  imports: [
    CommonModule,
    WhatsappVideoRoutingModule,
    SharedModule,
    CommonFileUploadModule

  ],exports:[
    WhatsappVideoComponent
  ]
})
export class WhatsappVideoModule { }
